var map = {
	"./bhalurent.gif": 9630,
	"./bhalurent.mp4": 661,
	"./bhalurent.png": 9329,
	"./botkraft.png": 3823,
	"./bridge.mp4": 7579,
	"./bunkmyjiit.gif": 1711,
	"./bunkmyjiit.mp4": 8296,
	"./bunkmyjiit.png": 2800,
	"./bytesweep.gif": 7355,
	"./bytesweep.png": 204,
	"./bytesweep2.png": 2004,
	"./oak.png": 4753,
	"./pyqjiit.gif": 8015,
	"./pyqjiit.mp4": 6248,
	"./velvet.mp4": 4798
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8394;